export enum StorageTypes {
	COOKIES,
	LOCAL_STORAGE,
	SESSION_STORAGE
}
